MetricsHelperFactory.$inject = ['$translate'];
/**
 * @deprecated
 * migrated in utils.service.ts
 */
export function MetricsHelperFactory($translate) {
  function formatHms(delta) {
    if (delta === null) {
      return ''
    }
    if (delta >= 0 && delta < 1) {
      return '0';
    }
    let retval = [];
    let d = Math.floor(delta / (3600*24));
    delta -= d * 3600*24;
    let h = Math.floor(delta / 3600);
    delta -= h * 3600;
    let m = Math.floor(delta / 60);
    delta -= m * 60;
    let s = Math.floor(delta);
    if (d > 0) {
      retval.push(d + $translate.instant('metrics/day/short'));
    }
    if (h > 0) {
      retval.push(h + $translate.instant('hour_short'));
    }
    if (m > 0) {
      retval.push(m + $translate.instant('minute_short'));
    }
    if (s > 0) {
      retval.push(s + $translate.instant('second_short'));
    }

    if (retval.length > 2) {
      retval = retval.slice(0, 2);
    }
    return retval.join(' ');
  }

  return {
    formatHms: formatHms
  };

}
